import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Input from 'antd/lib/input';
import React from 'react';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField'; // NOTE: Input.TextArea was introduced in 2.12.0 and removed in 3.0.0.
// istanbul ignore next

var _ref = Input.TextArea ? [Input.TextArea, {}] : [Input, {
  type: 'textarea'
}],
    _ref2 = _slicedToArray(_ref, 2),
    TextArea = _ref2[0],
    textAreaProps = _ref2[1];

var LongText = function LongText(props) {
  return wrapField(props, React.createElement(TextArea, Object.assign({
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    },
    placeholder: props.placeholder,
    ref: props.inputRef,
    value: props.value
  }, textAreaProps, filterDOMProps(props))));
};

LongText.defaultProps = {
  rows: 5
};
export default connectField(LongText);